const CircleCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <circle cx="12" cy="12.5" r="11.5" fill="#0AC4B2" stroke="#0AC4B2" />
      <path
        d="M5.61523 11.883L9.30347 17.5L17.9094 6.5"
        stroke="white"
        strokeWidth="1.77941"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CircleCheckIcon;
